import { getRequest, patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

const getSelectedLeaguesAdmin = async () => {
  try {
    const { response, logComplete } = await getRequest('leaguesAdmin', {})
    logComplete()
    return response
  } catch (error) {
    logger.error('getSelectedLeaguesAdmin', error)
    throw error
  }
}

const patchLeaguesAdmin = async (leaguesToProcess) => {
  try {
    const { response, logComplete } = await patchRequest('leaguesAdmin', { leaguesToProcess })
    logComplete()
    return response
  } catch (error) {
    logger.error('patchLeaguesAdmin', error)
    throw error
  }
}

export { getSelectedLeaguesAdmin, patchLeaguesAdmin }
